export const RP_STATUS_COMPANY = 1
export const RP_STATUS_DEPARTMENT = 2
export const RP_STATUS_CASEOWNER = 3

export const KEY_STATUS_COMPANY = "RecruitmentPerformanceContractorDepartment"
export const KEY_STATUS_DEPARTMENT = "RecruitmentPerformanceContractorSpecialistList"
export const KEY_STATUS_CASEOWNER = "RecruitmentPerformanceContractorRelated"

export class ReqRecruitmentPerformanceCount {
    constructor({ status=RP_STATUS_CASEOWNER, companyId, departmentId, caseOwner, startDate, endDate, start=0, limit=10 }) {
        this.status = status
        this.companyId = companyId
        this.departmentId = departmentId
        this.caseOwner = caseOwner
        this.startDate = startDate
        this.endDate = endDate
        this.start = start
        this.limit = limit
    }

    fromJson(jsonData) {
        if (jsonData !== undefined) {
            this.status = jsonData.status
            this.companyId = jsonData.companyId
            this.departmentId = jsonData.departmentId
            this.caseOwner = jsonData.caseOwner
            this.startDate = jsonData.startDate
            this.endDate = jsonData.endDate
            this.start = jsonData.start
            this.limit = jsonData.limit
        }
    }
}
export class ReqRecruitmentPerformanceDepartmentList {
    constructor({ companyId, start, limit, caseStatus }) {
        this.companyId = companyId
        this.start = start
        this.limit = limit
        this.caseStatus = caseStatus
    }

    fromJson(jsonData) {
        if (jsonData !== undefined) {
            this.companyId = jsonData.companyId
            this.caseStatus = jsonData.caseStatus
            this.start = jsonData.start
            this.limit = jsonData.limit
        }
    }
}

export class ReqRecruitmentPerformanceSpecialistList {
    constructor({ companyId, departmentId, start, limit, caseStatus }) {
        this.companyId = companyId
        this.departmentId = departmentId
        this.start = start
        this.limit = limit
        this.caseStatus = caseStatus
    }

    fromJson(jsonData) {
        if (jsonData !== undefined) {
            this.companyId = jsonData.companyId
            this.departmentId = jsonData.departmentId
            this.caseStatus = jsonData.caseStatus
            this.start = jsonData.start
            this.limit = jsonData.limit
        }
    }
}

export class ReqRecruitmentPerformanceContractorRelatedList {
    constructor({ companyId, departmentId, caseOwner, start, limit, caseStatus }) {
        this.companyId = companyId
        this.departmentId = departmentId
        this.caseOwner = caseOwner
        this.start = start
        this.limit = limit
        this.caseStatus = caseStatus
    }

    fromJson(jsonData) {
        if (jsonData !== undefined) {
            this.companyId = jsonData.companyId
            this.departmentId = jsonData.departmentId
            this.caseOwner = jsonData.caseOwner
            this.caseStatus = jsonData.caseStatus
            this.start = jsonData.start
            this.limit = jsonData.limit
        }
    }
}


export class ReqRecruitmentContractorDetail {
    constructor({ recruitmentContractorId }) {
        this.recruitmentContractorId = recruitmentContractorId
    }
}